export enum QueryKeyEnum {
  TOKEN = 'TOKEN',
  RESTAURANTS = 'RESTAURANTS',
  RESTAURANT_BY_SLUG = 'RESTAURANT_BY_SLUG',
  RESTAURANT_BY_SEARCH = 'RESTAURANT_BY_SEARCH',
  RESTAURANT_BY_FILTER = 'RESTAURANT_BY_FILTER',
  RESTAURANT_BY_CATEGORIES = 'RESTAURANT_BY_CATEGORIES',
  RESTAURANT_BY_RATINGS = 'RESTAURANT_BY_RATINGS',
  RESTAURANT_BY_PROMO = 'RESTAURANT_BY_PROMO',
  RESTAURANT_CATEGORIES = 'RESTAURANT_CATEGORIES',
  MARKETS = 'MARKETS',
  MARKETS_PROMOTION = 'MARKETS_PROMOTION',
  MARKET_PROMOTION_FOR_PROVIDER = 'MARKET_PROMOTION_FOR_PROVIDER',
  MARKET_PROMOTION_BY_ID = 'MARKET_PROMOTION_BY_ID',
  MARKET_FILTER_CATEGORIES = 'MARKET_FILTER_CATEGORIES',
  MARKET_SEARCH = 'MARKET_SEARCH',
  MARKET_BY_SLUG = 'MARKET_BY_SLUG',
  MARKETS_MENU_CATEGORIES = 'MARKETS_MENU_CATEGORIES',
  MARKET_CATEGORIES = 'MARKET_CATEGORIES',
  USER_ORDERS = 'USER_ORDERS',
  ORDER = 'ORDER',
  PREORDER = 'PREORDER',
  CART = 'CART',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_MY_ADDRESS = 'CUSTOMER_MY_ADDRESS',
  CUSTOMER_MY_FAVORITES = 'CUSTOMER_MY_FAVORITES',
  CUSTOMER_MY_ORDERS = 'CUSTOMER_MY_ORDERS',
  CUSTOMER_SET_ADDRESS = 'CUSTOMER_SET_ADDRESS',
  CUSTOMER_UPDATE = 'CUSTOMER_UPDATE',
  CUSTOMER_ADD_TO_FAVORITES = 'CUSTOMER_ADD_TO_FAVORITES',
  CUSTOMER_REMOVED_FAVORITES = 'CUSTOMER_REMOVED_FAVORITES',
  PROMOTION = 'PROMOTION',
  PROMOTION_BANNERS = 'PROMOTION_BANNERS',
  PROMOTION_BY_ID = 'PROMOTION_BY_ID',
  PROMOTION_FOR_PROVIDER = 'PROMOTION_FOR_PROVIDER',
  PROMO_CATEGORY = 'PROMO_CATEGORY',
  PROMO_CATEGORY_MARKET = 'PROMO_CATEGORY_MARKET',
  CATEGORIES = 'CATEGORIES',
  CATEGORIES_BY_PROVIDER = 'CATEGORIES_BY_PROVIDER',
  CATEGORIES_BY_ID = 'CATEGORIES_BY_ID',
  PRODUCT_BY_NAME = 'PRODUCT_BY_NAME',
  PRODUCT_BY_CATEGORY = 'PRODUCT_BY_CATEGORY',
  PRODUCTS = 'PRODUCTS',
  BANNERS = 'BANNERS',
  BANNER_BY_CATEGORY = 'BANNER_BY_CATEGORY',
  SUGGESTION = 'SUGGESTION',
  SEARCH_PROVIDERS = 'SEARCH_PROVIDERS',
  SEARCH_PRODUCTS = 'SEARCH_PRODUCTS',
  SEARCH_AUTOCOMPLETE = 'SEARCH_AUTOCOMPLETE',
  DISTANCE_PRICE = 'DISTANCE_PRICE',
  DAILY_SPECIALS = 'DAILY_SPECIALS',
  SERVER_INFO_CONFIG = 'SERVER_INFO_CONFIG',
  DAILY_LUNCH = 'DAILY_LUNCH',
  CUSTOMER_CARDS = 'CUSTOMER_CARDS',
  SEARCH_RESTAURANTS_BY_CATEGORY = 'SEARCH_RESTAURANTS_BY_CATEGORY',
  CUSTOMER_PROMOCODE = 'CUSTOMER_PROMOCODE',
  CUSTOMER_PROMOS = 'CUSTOMER_PROMOS',
}

export enum StorageKeyEnum {
  ORDER = 'straus_order',
  CART = 'straus_cart',
  ACCESS_TOKEN = 'straus_access_token',
  REFRESH_TOKEN = 'straus_refresh_token',
  SAVED_ADDRESS = 'straus_saved_address',
  CUSTOMER_FAVORITES = 'straus_customer_favorites',
  COORDINATES = 'coordinates',
  CURRENT_PROVIDER = 'current_provider',
  CHECK_AGREEMENT = 'check_agreement',
  REGION_COORDS = 'REGION_COORDS',
}

export enum DeliveryMethodEnum {
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
}

export enum PaymentMethodEnum {
  CASH = 'cash',
  CARD = 'card',
  ApplePayGPay = 'ApplePayGPay',
  MIA = 'MIA',
  BPAY = 'BPAY',
}

export enum PriceLevelEnum {
  ONE = 1,
  TWO = 2,
  THREE = 3,
}

export enum OverloadLevelEnum {
  ZERO = 0,
  ONE = 1,
  THREE = 3,
}

export enum ProviderTypeEnum {
  RESTAURANT = 'restaurant',
  MARKET = 'market',
  COURIER_EXPRESS = 'COURIER_EXPRESS',
}

export enum ProviderPageTypeEnum {
  RESTAURANT = 'gallery',
  MARKET = 'eshop',
}

export enum OptionSetTypeEnum {
  ZERO = 0,
  ONE = 1,
}

export enum LanguageEnum {
  RU = 'ru',
  RO = 'ro',
  EN = 'en',
}

export enum OrderStatusEnum {
  NEW = 'c00', //Новый заказ, заказа отменен
  AUTO_CONFIRMED = 'c02', // заказаз подтвержден автоматически
  WAITING_PAYMENT = 'c05', // ожидает платежа
  PAYMENT_CONFIRMED = 'c07', // платеж подтвержден
  PAYMENT_FAILED = 'c08', // ошибка оплаты онлайн заказа
  PROCESSING = 'c10', // страус подтвердил, заказ подвержден
  PREPARING = 'c30', // ресторан подтвердил и начал готовить блюдо
  PICKED = 'c40', // курьер забрал / курьер в ресторане
  DELIVERING = 'c50', // на самом деле куриер забрал
  DELIVERING_CLIENT = 'c55', // курьер доставляет клиенту
  AT_CLIENT_PART1 = 'c60', // курьер у клиента
  AT_CLIENT = 'c70', // курьер у клиента
  DELIVERED = 'c80', // заказ доставлен
}
export enum OrderStatusEnumCourierExpress {
  NEW = 'e00', //Новый заказ, заказа отменен
  AUTO_CONFIRMED = 'e02', // заказаз подтвержден автоматически
  WAITING_PAYMENT = 'e05', // ожидает платежа
  PAYMENT_CONFIRMED = 'e07', // платеж подтвержден
  PAYMENT_FAILED = 'e08', // ошибка оплаты онлайн заказа
  PROCESSING = 'e10', // страус подтвердил, заказ подвержден
  PREPARING = 'e30', // ресторан подтвердил и начал готовить блюдо
  PICKED = 'e40', // курьер забрал / курьер в ресторане
  DELIVERING = 'e50', // курьер доставляет
  AT_CLIENT_PART1 = 'e60', // курьер у клиента
  AT_CLIENT = 'e70', // курьер у клиента
  DELIVERED = 'e80', // заказ доставлен
}

export type CustomerKeys = 'name' | 'email' | 'phonenumber';
